export default function Terms() {
  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '40px 20px',
      color: '#e5e7eb',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <h1 style={{ fontSize: '32px', fontWeight: 700, marginBottom: '24px' }}>Terms of Service</h1>
      <p style={{ color: '#9ca3af', marginBottom: '32px' }}>Last Updated: January 2026</p>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>1. Acceptance of Terms</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          By accessing or using UNYKORN ("the Service"), you agree to be bound by these Terms of Service.
          If you do not agree to these terms, please do not use the Service.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>2. Description of Service</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          UNYKORN is an institutional-grade XRPL (XRP Ledger) platform providing proof-of-funds verification,
          Xaman wallet integration, DEX trading, and related blockchain services. The Service is provided "as is"
          without warranties of any kind.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>3. User Responsibilities</h2>
        <ul style={{ lineHeight: '1.6', paddingLeft: '24px', marginBottom: '16px' }}>
          <li style={{ marginBottom: '8px' }}>You are responsible for securing your wallet credentials (seeds, private keys)</li>
          <li style={{ marginBottom: '8px' }}>You understand that blockchain transactions are irreversible</li>
          <li style={{ marginBottom: '8px' }}>You agree to use the Service in compliance with all applicable laws</li>
          <li style={{ marginBottom: '8px' }}>You will not attempt to disrupt or compromise the Service</li>
        </ul>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>4. Financial Disclaimer</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px', fontWeight: 600, color: '#fbbf24' }}>
          ⚠️ Important: UNYKORN does not provide financial, investment, or legal advice.
        </p>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          Cryptocurrency and blockchain transactions carry significant risk. You may lose all funds involved.
          Do your own research and consult qualified professionals before making financial decisions.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>5. Wallet Security</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          UNYKORN never stores your wallet seeds or private keys. You are solely responsible for:
        </p>
        <ul style={{ lineHeight: '1.6', paddingLeft: '24px', marginBottom: '16px' }}>
          <li style={{ marginBottom: '8px' }}>Backing up wallet credentials securely (offline, encrypted)</li>
          <li style={{ marginBottom: '8px' }}>Never sharing seeds/keys with anyone (including UNYKORN staff)</li>
          <li style={{ marginBottom: '8px' }}>Using strong passwords and 2FA where available</li>
          <li style={{ marginBottom: '8px' }}>Verifying transaction details before signing</li>
        </ul>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>6. Xaman Integration</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          When using Xaman (formerly XUMM) signing flows, you acknowledge that:
        </p>
        <ul style={{ lineHeight: '1.6', paddingLeft: '24px', marginBottom: '16px' }}>
          <li style={{ marginBottom: '8px' }}>Xaman is a third-party service operated by XRPL Labs</li>
          <li style={{ marginBottom: '8px' }}>You should review all transaction details in Xaman before signing</li>
          <li style={{ marginBottom: '8px' }}>UNYKORN is not responsible for Xaman's availability or operation</li>
          <li style={{ marginBottom: '8px' }}>You should only sign transactions you initiated</li>
        </ul>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>6.5 Third-Party xApp Disclaimer</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px', fontWeight: 600, color: '#fbbf24' }}>
          ⚠️ Important: UNYKORN is a third-party xApp, not operated or endorsed by XRPL Labs.
        </p>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          When using UNYKORN as a Xaman xApp, you acknowledge that:
        </p>
        <ul style={{ lineHeight: '1.6', paddingLeft: '24px', marginBottom: '16px' }}>
          <li style={{ marginBottom: '8px' }}>XRPL Labs (Xaman operator) does not endorse, guarantee, or assume liability for this xApp</li>
          <li style={{ marginBottom: '8px' }}>This xApp is independently developed and maintained by UNYKORN</li>
          <li style={{ marginBottom: '8px' }}>XRPL Labs is not responsible for xApp functionality, bugs, or data loss</li>
          <li style={{ marginBottom: '8px' }}>You use this xApp at your own risk</li>
          <li style={{ marginBottom: '8px' }}>Report xApp-specific issues to UNYKORN support, not XRPL Labs</li>
        </ul>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>7. Limitation of Liability</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, UNYKORN SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL,
          SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING LOSS OF PROFITS, DATA, OR FUNDS, ARISING FROM
          YOUR USE OF THE SERVICE.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>8. Service Modifications</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          We reserve the right to modify, suspend, or discontinue any part of the Service at any time without notice.
          We may also update these Terms; continued use constitutes acceptance of modified Terms.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>9. Prohibited Activities</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>You agree not to:</p>
        <ul style={{ lineHeight: '1.6', paddingLeft: '24px', marginBottom: '16px' }}>
          <li style={{ marginBottom: '8px' }}>Use the Service for money laundering, terrorism financing, or other illegal activities</li>
          <li style={{ marginBottom: '8px' }}>Attempt to hack, disrupt, or reverse engineer the Service</li>
          <li style={{ marginBottom: '8px' }}>Impersonate others or misrepresent your affiliation</li>
          <li style={{ marginBottom: '8px' }}>Violate intellectual property rights</li>
        </ul>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>10. Governing Law</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          These Terms shall be governed by and construed in accordance with applicable laws. Any disputes
          shall be resolved through binding arbitration in accordance with commercial arbitration rules.
        </p>
      </section>

      <section style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px' }}>11. Contact</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '16px' }}>
          For questions about these Terms, please contact us through the platform's contact form or
          visit our website at <a href="https://unykorn.org" style={{ color: '#3b82f6' }}>unykorn.org</a>.
        </p>
      </section>

      <div style={{
        marginTop: '48px',
        padding: '24px',
        background: 'rgba(59, 130, 246, 0.1)',
        border: '1px solid rgba(59, 130, 246, 0.2)',
        borderRadius: '12px'
      }}>
        <p style={{ fontSize: '14px', color: '#9ca3af', lineHeight: '1.6' }}>
          By using UNYKORN, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
        </p>
      </div>
    </div>
  );
}
